import React from 'react';

const BlogIndex = () => {
  return (
    <div>Blog</div>
  );
};

export default BlogIndex;
